import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { SimsProvider } from './context/SimsContext';
import { StockDharmaProvider } from './context/StockDharmaContext';
import { ThemeProvider } from './context/ThemeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerServiceWorker } from './utils/registerServiceWorker';
import './services/offlineSyncService'; // Initialize offline sync listeners

import { LocationProvider } from './context/LocationContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 seconds fresh window
      gcTime: 1000 * 60 * 5, // Keep unused data in cache for 5 minutes
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: true, // Refetch when mounting if data is stale
      retry: 1,
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));

// Service Worker: Only register in production; unregister in development to eliminate HMR reload loops
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else {
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) {
        reg.unregister();
      }
    });
  }
}

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <LocationProvider>
                    <SimsProvider>
                        <StockDharmaProvider>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </StockDharmaProvider>
                    </SimsProvider>
                </LocationProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
